<template>
    <div>
        <h2 class="mb-3" v-html="$t('intern_buchungen.titel_buchungen')"></h2>

        <div v-if="user_packets">
            <h5 class="text-muted">Aktuelles Paket</h5>
            <div>
                <table class="table table-striped mb-5">
                    <tr>
                        <th>{{$t('intern_buchungen.header_pakete')}}</th>
                        <td>
                            {{user_packets.quota}}
                            {{user_packets.quota > 1 ? 'Inserate' : 'Inserat'}}
                            <!-- /{{user_packets.duration}}
                            {{user_packets.duration > 1 ? 'Monate' : 'Monat'}}   -->
                        </td>
                    </tr>
                    <tr>
                        <th>{{$t('intern_buchungen.netto')}}</th>
                        <td>{{user_packets.price | netto | currency}}</td>
                    </tr>
                    <tr>
                        <th>{{$t('intern_buchungen.brutto')}}</th>
                        <td>{{user_packets.price | currency}}</td>
                    </tr>
                    <tr>
                        <th>Laufzeit</th>
                        <td>{{user_packets.duration}} {{user_packets.duration > 1 ? 'Monate' : 'Monat'}}</td>
                    </tr>
                    <tr>
                        <th>{{$t('intern_buchungen.gebucht_seit')}}</th>
                        <td>{{user_packets.start | date}}</td>
                    </tr>
                    <tr>
                        <th>{{$t('intern_buchungen.gebucht_bis')}}</th>
                        <td>{{user_packets.expires_at | date}}</td>
                    </tr>
                    <tr>
                        <th>Umkreis</th>
                        <td>{{formatUmkreis(user_packets.perimeter)}}</td>
                    </tr>
                    <tr v-if="user_packets.type == 'custom'">
                        <th>Startseiten Fotolink</th>
                        <td>{{user_packets.fotolink}}</td>
                    </tr>
                    <tr v-if="user_packets.type == 'custom'">
                        <th>Kategorie Fotolinks</th>
                        <td>{{user_packets.fotokategorie}}</td>
                    </tr>
                    <tr v-if="user_packets.type == 'custom'">
                        <th>Top Inserat</th>
                        <td>{{user_packets.topinserat}}</td>
                    </tr>
                    <tr v-if="user_packets.type == 'custom'">
                        <th>Daily Pushup</th>
                        <td>{{user_packets.dailypushup}}</td>
                    </tr>
                    <tr v-if="user_packets.type == 'custom'">
                        <th>Weekly Pushup</th>
                        <td>{{user_packets.weeklypushup}}</td>
                    </tr>
                    <tr v-if="user_packets.type == 'custom'">
                        <th>{{$t('intern_buchungen.status')}}</th>
                        <td v-if="user_packets.status == 'running' && user_packets.canceled == 0" v-html="$t('intern_buchungen.laufend')"></td>
                        <td v-else-if="user_packets.status == 'running' && user_packets.canceled == 1" v-html="$t('intern_buchungen.gekuendigt')"></td>
                        <td v-else-if="user_packets.status == 'canceled'" v-html="$t('intern_buchungen.gekuendigt')"></td>
                        <td v-else><span v-html="$t('intern_buchungen.abgelaufen')"></span></td>
                    </tr>
                    <tr v-else>
                        <th>{{$t('intern_buchungen.status')}}</th>
                        <td>
                            <span v-if="user_packets.status == 'running' && user_packets.canceled == 0" v-html="$t('intern_buchungen.laufend')"></span>
                            <span v-else-if="user_packets.status == 'running' && user_packets.canceled == 1" v-html="$t('intern_buchungen.gekuendigt')"></span>
                            <span v-else-if="user_packets.status == 'expired'" v-html="$t('intern_buchungen.abgelaufen')"></span>
                            &nbsp;
                            <input type="button"
                                v-if="user_packets.status != 'expired' && user_packets.status != 'deleted' && user_packets.canceled == 1"
                                @click="confirmation('user',user_packets.id, reactivate)"
                                class="font-12 btn btn-light rounded" value="Reaktivieren"/>
                            <input type="button"
                                class=" font-12 btn btn-light rounded"
                                v-if="user_packets.status != 'expired' && user_packets.status != 'canceled' && user_packets.canceled == 0"
                                @click="confirmation('user',user_packets.id, cancel)" value="Kündigen"/>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-if="object_packets && object_packets.length > 0">
            <div v-if="isMobile">
                <h5 class="text-muted text-center mb-3">Zusatzleistungen</h5>
                <table class="table table-striped" v-for="packet in object_packets" :key="packet.id">
                        <tr>
                            <th v-html="$t('intern_buchungen.buchungen_zusatz')" style="width: 230px;"></th>
                            <td>{{getExtension(packet.packet_key).title}}
                              <div>
                                <span class="font-12">
                                    Inserats-Nummer: {{packet.object_id}}
                                </span>
                              </div>
                            </td>
                        </tr>
                        <tr>
                            <th v-html="$t('intern_buchungen.netto')"></th>
                            <td>{{getExtension(packet.packet_key).price | netto | currency}}</td>
                        </tr>
                        <tr>
                            <th v-html="$t('intern_buchungen.brutto')"></th>
                            <td>{{getExtension(packet.packet_key).price | currency}}</td>
                        </tr>
                        <tr>
                            <th v-html="$t('intern_buchungen.gebucht_seit')"></th>
                            <td>{{packet.start | date}}</td>
                        </tr>
                        <tr>
                            <th v-html="$t('intern_buchungen.gebucht_bis')"></th>
                            <td>{{packet.end | date}}</td>
                        </tr>
                        <tr>
                            <th v-html="$t('intern_buchungen.status')"></th>
                            <td>
                                <span v-if="packet.status == 'running' && packet.canceled == 0" v-html="$t('intern_buchungen.laufend')"></span>
                                <span v-else-if="packet.status == 'running' && packet.canceled == 1" v-html="$t('intern_buchungen.gekuendigt')"></span>
                                <span v-else-if="packet.status == 'expired'" v-html="$t('intern_buchungen.abgelaufen')"></span>
                                <div v-if="user_packets.canceled == 0">
                                    <input type="button"
                                        v-if="packet.status != 'expired' && packet.status != 'deleted' && packet.canceled == 1"
                                        class="mm-link btn btn-light rounded"
                                        @click="confirmation('object',packet.id, reactivate)"
                                        value="Reaktivieren"/>
                                    <input type="button"
                                        v-if="packet.status != 'expired' && packet.canceled == 0"
                                        class="btn btn-light rounded" style="text-decoration: underline"
                                        @click="confirmation('object',packet.id, cancel)"
                                        value="Kündigen"/>
                                </div>
                            </td>
                        </tr>
                </table>
            </div>
            <div v-else>
                <h5 class="text-muted">Zusatzleistungen</h5>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th v-html="$t('intern_buchungen.buchungen_zusatz')"></th>
                            <th v-html="$t('intern_buchungen.netto')"></th>
                            <th v-html="$t('intern_buchungen.brutto')"></th>
                            <th v-html="$t('intern_buchungen.gebucht_seit')"></th>
                            <th v-html="$t('intern_buchungen.gebucht_bis')"></th>
                            <th v-html="$t('intern_buchungen.status')" v-if="user_packets && user_packets.type != 'custom'"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="packet in object_packets" :key="packet.id">
                            <td>{{getExtension(packet.packet_key).title}}
                              <div>
                                <span class="font-12">
                                    Inserats-Nummer: {{packet.object_id}}
                                </span>
                              </div>
                            </td>
                            <td>{{getExtension(packet.packet_key).price | netto | currency}}</td>
                            <td>{{getExtension(packet.packet_key).price | currency}}</td>
                            <td>{{packet.start | date}}</td>
                            <td>{{packet.end | date}}</td>
                            <td v-if="(user_packets && user_packets.type != 'custom') || (!user_packets && user && user.user_type == 'alter_kunde')">
                                <span v-if="packet.status == 'running' && packet.canceled == 0" v-html="$t('intern_buchungen.laufend')"></span>
                                <span v-else-if="packet.status == 'running' && packet.canceled == 1" v-html="$t('intern_buchungen.gekuendigt')"></span>
                                <span v-else-if="packet.status == 'expired'" v-html="$t('intern_buchungen.abgelaufen')"></span>
                                <div class="mx-n3" v-if="user_packets.canceled == 0">
                                    <input type="button"
                                        v-if="packet.status != 'expired' && packet.status != 'deleted' && packet.canceled == 1"
                                        class=" font-12 btn btn-light rounded"
                                        @click="confirmation('object',packet.id, reactivate)"
                                        value="Reaktivieren"/>
                                    <input type="button"
                                        v-if="packet.status != 'expired' && packet.canceled == 0"
                                        class=" btn btn-light rounded font-12"
                                        @click="confirmation('object',packet.id, cancel)"
                                        value="Kündigen" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="mt-5" style="border-top: 2px solid grey; ">
          <!--this div is just for <hr> tag-->
        </div>
        <!--<div class="container">
          <div v-if="object_packets.length > 0">
            <input type="button" class="btn btn-success rounded center-button" value="Weitere Zusatzleistungen buchen" @click="RedirectToAdditionalServices()">
          </div>
        </div>-->
        <div class="mt-5" v-if="user_packets_old && user_packets_old.length > 0">
          <h5 class="text-muted"> Abgelaufene Leistungen</h5>
        </div>
        <div class="mb-5" v-if="user_packets_old && user_packets_old.length > 0">
          <table class="table table-striped">
              <thead>
                  <tr>
                      <th v-html="$t('intern_buchungen.article')"></th>
                      <th v-html="$t('intern_buchungen.netto')"></th>
                      <th v-html="$t('intern_buchungen.brutto')"></th>
                      <th v-html="$t('intern_buchungen.start_of_term')"></th>
                      <th v-html="$t('intern_buchungen.end_of_term')"></th>
                      <th v-html="$t('intern_buchungen.status')"></th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="user in user_packets_old" :key="user.id">
                      <td>
                          <span class="font-12">
                               {{user.name}}
                          </span>

                      </td>
                      <td>{{user.price | netto | currency}}</td>
                      <td>{{user.price | currency}}</td>
                      <td>{{user.start | date}}</td>
                      <td>{{user.expires_at | date}}</td>
                      <td>
                        abgelaufen
                      </td>
                  </tr>
              </tbody>
          </table>
        </div>
        <div class="mt-5" v-if="object_packets_expired && object_packets_expired.length > 0">
          <table class="table table-striped">
              <thead>
                  <tr>
                      <th v-html="$t('intern_buchungen.additional_service_title')"></th>
                      <th v-html="$t('intern_buchungen.netto')"></th>
                      <th v-html="$t('intern_buchungen.brutto')"></th>
                      <th v-html="$t('intern_buchungen.start_of_term')"></th>
                      <th v-html="$t('intern_buchungen.end_of_term')"></th>
                      <th v-html="$t('intern_buchungen.status')"></th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="packet in object_packets_expired" :key="packet.id">
                      <td>{{getExtension(packet.packet_key).title}}
                        <div>
                          <span class="font-12">
                              Inserats-Nummer: {{packet.object_id}}
                          </span>
                        </div>
                      </td>
                      <td>{{getExtension(packet.packet_key).price | netto | currency}}</td>
                      <td>{{getExtension(packet.packet_key).price | currency}}</td>
                      <td>{{packet.start | date}}</td>
                      <td>{{packet.end | date}}</td>
                      <td>
                        abgelaufen
                      </td>
                  </tr>
              </tbody>
          </table>
        </div>
        <div class="alert alert-warning mt-3" v-if="!user_packets && !user_packets_old && (object_packets && object_packets.length == 0) && (object_packets_expired && object_packets_expired.length == 0)">
            Sie haben noch keine Verträge bei uns!
        </div>
        <b-modal ref="confirm-modal" :title="'Bestätigung'" v-if="confirm_packet != {}">
            <div class="d-block">
                <h5>{{confirm_packet.message}}</h5>
            </div>
            <template slot="modal-footer">
                <b-button variant="secondary" @click="hideModal()">Abbrechen</b-button>
                <b-button variant="success" @click="togglePacket()">Bestätigen</b-button>
            </template>
        </b-modal>
        <loading v-if="loading"/>
        <b-toast id="my-toast" variant="success" solid>
            {{success}}
        </b-toast>
    </div>
</template>

<script>
    import { IsMobileMixin } from '../../mixins/IsMobile';

    export default {
        name: 'konto-vertraege',
        data() {
            return {
                user : [],
                user_packets: null,
                user_packets_old: null,
                object_packets: [],
                object_packets_expired: [],
                object_packets_not_premium: [],
                objects: [],
                extensions: [],
                reactivate: 0,
                cancel: 1,
                confirm_packet: {},
                loading: false,
                success: ''
            }
        },
        mixins: [IsMobileMixin],
        methods: {
            fetchVertraege() {
                this.$store.state.loading = true;
                this.$http.get('/buchungApi/getAll').then(response => {
                    const data          = JSON.parse(response.data);
                    this.user_packets   = data.user_packets;
                    this.user_packets_old   = data.user_packets_old;
                    this.objects        = data.objects;
                    this.object_packets = data.object_packets;
                    this.object_packets_expired = data.object_packets_expired;
                    this.extensions     = data.extensions;
                    this.user     = data.user;
                }).catch(error => { console.log(error); }).then(() => {
                    this.$store.state.loading = false;
                });
            },
            getObject(id) {
                return this.objects.find(object => object.id == id);
            },
            getExtension(key) {
                return this.extensions.find(ext => ext.key == key);
            },
            RedirectToAdditionalServices(){
              //this.$router.push({ name: 'inserat-booking', params: { object_id: this.object.id} });
            },
            togglePacket() {
                let url = '/' + this.confirm_packet.type;
                url += (this.confirm_packet.status) ? 'PacketApi/cancelPacket' : 'PacketApi/activatePacket';
                this.$refs['confirm-modal'].hide();
                this.loading = true;
                this.$http.post(url, {id: this.confirm_packet.id , object_packets: this.object_packets}).then(
                    response => {
                        let data = JSON.parse(response.data);
                        this.loading = false;
                        this.success = data.msg;
                        this.$bvToast.show('my-toast');
                        setTimeout(() => {
                            this.$bvToast.hide('my-toast');
                        }, 4000);
                        this.fetchVertraege();
                    }
                ).catch(error => {
                    console.log(error);
                    this.loading = false;
                });

                this.confirm_packet = {};
            },
            confirmation(type, id, status) {
                let message = (status) ? 'Möchten Sie Ihr Inserats-Paket bzw. Ihre Zusatzleistung wirklich kündigen? ' : 'Möchten Sie Ihr Paket bzw. die Zusatzoption wirklich reaktivieren?';


                /*let message = (type == 'object') ? 'Möchtest Du das Paket bzw. die Zusatzoption ' : 'Möchtest Du das Paket ';
                message += (status) ? 'wirklich kündigen?' : 'reaktivieren?';*/

                this.confirm_packet = {
                    type,
                    id,
                    status,
                    message
                };

                this.$refs['confirm-modal'].show();
            },
            hideModal() {
                this.confirm_packet = {};
                this.$refs['confirm-modal'].hide();
            },
            formatUmkreis(umkreis) {
                if( ! umkreis || umkreis > 900 || umkreis == 0){
                    return this.$t('intern_inserieren.deutschlandweit')
                }
                return umkreis + ' km';
            }
        },
        created() {
            document.title = 'Meine Verträge';
            this.fetchVertraege();
        },
    }
</script>

<style scoped>
.center-button{
  margin: auto;
  display: inherit;
}
.btn-light{
  background-color: #e9e6e6 !important;
}
.btn-light:hover{
  background-color: #d9d6d6 !important;
}
table tr{
    font-size: 14px;
}
</style>
